
import { AssignedSubApplications, SubApplicationLabels } from "../request.interface"


export interface UserApiResponse{
  data : UserApiUser;
}

export interface UserApiUser{
  userID : number;
  loginID : string;
  displayName : string;
}
export interface UserViewModel {
  loginID: string;
  id: number;
  displayName: string;
  NWAs: NWAModel[];
  Routes: string[];
  permissions: PermissionViewModel[];
  AssignedSubApplications: AssignedSubApplications[];
  SubApplicationLabels: SubApplicationLabels;
}
export interface PermissionViewModel {
  id: number;
  name: string;
  description: string;
  isSAPRelated: boolean
}
export interface NWAModel {
  ID: number;
  DisplayName: string;
  LoginID: string;
  Email: string;
  RoleID: number;
  RoleName: string;
  Active: boolean;
  NWAID: number;
  NWAName: string;
}

export interface EmployeeAccessViewModel {
  routs: RouterViewModel[];
}

export interface RouterViewModel {
  Id: number;
  Title: string;
  Icon: string;
  Disabled: boolean;
  Description: string;
  Order: string;
  Selected: boolean;
  Permission: string;
}
export enum Permissions {
  ADMIN = 'ADMIN',
  ADESC_USER = 'ADESC_USER',
  ADESC_MANAGE_GEOGRAPHIES = 'ADESC_MANAGE_GEOGRAPHIES',
  ADESC_MANAGE_APPLICATIONS = 'ADESC_MANAGE_APPLICATIONS',
  ADESC_MANAGE_ADE_AE = 'ADESC_MANAGE_ADE_AE',
  SUBMIT_FC_OPERATIONS_RTA = 'SUBMIT_FC_OPERATIONS_RTA',
  SUBMIT_RC_OPERATIONS_RTA = 'SUBMIT_RC_OPERATIONS_RTA',
  SUBMIT_INTERNAL_RTA = 'SUBMIT_INTERNAL_RTA',
  ADESC_ADMIN = 'ADESC_ADMIN',
  CANCEL_RTA = 'CANCEL_RTA',
  HOLD_RTA = 'HOLD_RTA',
  SUSTAINING = 'SUSTAINING',
  MFG_ENG = 'MFG_ENG',
  NC = 'NC',
  ACCOUNTING = 'ACCOUNTING',
  QUALITY = 'QUALITY',
  CUSTOMER_SVC = 'CUSTOMER_SVC',
  PROCUREMENT = 'PROCUREMENT',
  VIEW_EJDF = 'VIEW_EJDF',
  VIEW_RTA_PRIORITY = 'VIEW_RTA_PRIORITY',
  FC_USER = 'FC_USER',
  RC_USER = 'RC_USER',
  SUBMIT_RTA_WITHOUT_APPROVAL = 'SUBMIT_RTA_WITHOUT_APPROVAL',
  DBTM_APPROVE_RTA = 'DBTM_APPROVE_RTA',
  CLOSE_RTA = 'CLOSE_RTA',
  EDIT_EJDF = 'EDIT_EJDF',
  TECH_USER = 'TECH_USER',
  COORDINATOR = 'COORDINATOR',
  ADESC_MANAGE_TECHNOLOGY_USERS = 'ADESC_MANAGE_TECHNOLOGY_USERS',
  WIZDOM_MANAGE_USERS = 'WIZDOM_MANAGE_USERS',
  WIZDOM_USER = 'WIZDOM_USER',
  ADESC_MANAGE_NWAS = 'ADESC_MANAGE_NWAS',
  ADESC_MANAGE_SUBAPPLICATIONS = 'ADESC_MANAGE_SUBAPPLICATIONS',
  WIZDOM_APPROVE_ACCESS = 'WIZDOM_APPROVE_ACCESS',
  ADESC_APPROVE_ACCESS = 'ADESC_APPROVE_ACCESS',
  COUNTRY_MANAGER_APPROVE_RTA = 'COUNTRY_MANAGER_APPROVE_RTA',
  WIZDOM_BIT_COMPARE = 'WIZDOM_BIT_COMPARE',
  WIZDOM_BIT_COMPARE_DIAGNOSTIC = 'WIZDOM_BIT_COMPARE_DIAGNOSTIC',
  TASK_MANAGER = 'TASK_MANAGER',
  INCIDENT_TRACKER_EDITOR = 'INCIDENT_TRACKER_EDITOR',
  WIZDOM_APPROVE_CASE_HISTORY = 'WIZDOM_APPROVE_CASE_HISTORY',
  ADESC_CUTTER_POSITION_ACCESS = 'ADESC_CUTTER_POSITION_ACCESS',
  DHT_USER = 'DHT_USER',
  SUBMIT_DHT_OPERATIONS_RTA = 'SUBMIT_DHT_OPERATIONS_RTA',
  CORING_USER = 'CORING_USER',
  PRODUCT_OWNER = 'PRODUCT_OWNER',
  WIZDOM_APPROVE_BITRECORD = 'WIZDOM_APPROVE_BITRECORD',
  SUBMIT_PERFORMANCE_ALERT = 'SUBMIT_PERFORMANCE_ALERT',
  SUBMIT_PROPOSAL = 'SUBMIT_PROPOSAL',
  ADESC_CUTTER_MAP_ACCESS = 'ADESC_CUTTER_MAP_ACCESS',
  FILEVAULT_VIEWQNOTE = 'FILEVAULT_VIEWQNOTE',
  FILEVAULT_VIEWPRODUCTION = 'FILEVAULT_VIEWPRODUCTION',
  FILEVAULT_ADMIN = 'FILEVAULT_ADMIN',
  FILEVAULT_SUPERADMIN = 'FILEVAULT_SUPERADMIN',
  BHA_READER = 'BHA_READER',
  BHA_ADMIN = 'BHA_ADMIN',
  OPSDESKTOP_RECEIVE_STOCKPOINT_UPDATE = 'OPSDESKTOP_RECEIVE_STOCKPOINT_UPDATE',
  VIEW_ZJMS_DATA = 'VIEW_ZJMS_DATA',
  CAN_EDIT_AREA_PRODUCT_PORTFOLIO = 'CAN_EDIT_AREA_PRODUCT_PORTFOLIO',
  HART_USER = "HART_USER",
  HART_ADMIN = "HART_ADMIN",
  HART_CUTTERMAPPER = "HART_CUTTERMAPPER",
  HART_TASK_MANAGER = "HART_TASK_MANAGER",
  HART_TASK_ROLLBACK = "HART_TASK_ROLLBACK",
  HART_REPAIR_DATA_EDITOR = "HART_REPAIR_DATA_EDITOR",
  HART_CREATE_ESTIMATE = "HART_CREATE_ESTIMATE",
  HART_SUBMIT_REPAIR_ENTRY = "HART_SUBMIT_REPAIR_ENTRY",
  HART_PROCESSOR = "HART_PROCESSOR",
  HART_DELETEREPAIR = "HART_DELETEREPAIR",
  HART_SCRAP_APPROVAL = "HART_SCRAP_APPROVAL",
  HART_REPAIR_APPROVAL = "HART_REPAIR_APPROVAL",
  HART_REPAIR_ACCESS = "HART_REPAIR_ACCESS",
  HART_TASK_REWORK = "HART_TASK_REWORK",
  HART_REPAIR_SCHEDULER = "HART_REPAIR_SCHEDULER",
  HART_REPAIR_SCHEDULER_ADMIN = "HART_REPAIR_SCHEDULER_ADMIN",
  HART_CUTTER_TYPE_ASSIGN = "HART_CUTTER_TYPE_ASSIGN",
  HART_CUTTER_TYPE_ASSIGN_ADMIN = "HART_CUTTER_TYPE_ASSIGN_ADMIN",
  HART_CUTTER_TYPE_LOCK = "HART_CUTTER_TYPE_LOCK",
  HART_CUTTER_EVALUATOR = "HART_CUTTER_EVALUATOR",
  HART_REPAIR_DATA_EDITOR_ADMIN = "HART_REPAIR_DATA_EDITOR_ADMIN",
  RTA_FROPS_APPROVAL = "RTA_FROPS_APPROVAL",
  RTA_FRDT_APPROVAL = "RTA_FRDT_APPROVAL",
  RTA_FRM_APPROVAL = "RTA_FRM_APPROVAL",
  RTA_FR_USER = "RTA_FR_USER",
  RTA_ADMIN = "RTA_ADMIN"
}


export enum Roles {
  OPERATIONS = "Operations",
  COUNTRY_MANAGER = "Country Manager",
  OMC = "OMC",
  OTC = "OTC",
  HDBS_TECHNOLOGY_SOFTWARE_DEVELOPER = "HDBS Technology Software Developer"
}
